import { Component, OnChanges, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { ContentService } from '@blk/cwp-ng-framework';
import { CellData } from '@ddt-web/data-service';
import { DialogConfig, DialogRef } from '@ddt-web/dialog';
import { Memoize } from '@ddt-web/generic-utils';
import * as cloneDeep from 'lodash/cloneDeep';
import * as get from 'lodash/get';

import { ScenarioCategories } from '../../models';
import { ScenarioService } from '../../services';
import { ScenarioCategoryUtil } from '../../utils/scenario-category.util';


@Component({
	selector: 'sc-scenario-selection-dialog',
	templateUrl: './scenario-selection-dialog.component.html',
	styleUrls: ['./scenario-selection-dialog.component.scss']
})
export class ScenarioSelectionDialogComponent implements OnInit, OnChanges {
	public data: any;

	public selectedScenarioKeys: Array<string> = [];

	private allScenarios: CellData[];
	public filteredScenarios: CellData[] = [];

	public categorisedScenarios: ScenarioCategories;
	private categorisedScenarioStrings: ScenarioCategories;

	public hypotheticalScenarioCategories = ['interest', 'bonds', 'commodities', 'equities'];

	constructor(
		private contentService: ContentService,
		private scenarioService: ScenarioService,
		config: DialogConfig,
		public dialogRef: DialogRef
	) {
		this.data = config.data;
	}

	public ngOnInit(): void {
		this.updateScenariosData();
	}

	public ngOnChanges(): void {
		this.updateScenariosData();
	}

	private updateScenariosData(): void {
		if (this.data) {
			this.selectedScenarioKeys = get(this.data, 'selectedScenarios', []).map((scenario: CellData) => scenario.rawValue);
			this.allScenarios = get(this.data, 'allScenarios', []).slice(0);
			this.filteredScenarios = cloneDeep(this.allScenarios);
			this.categorisedScenarioStrings = ScenarioCategoryUtil.getScenarioCategories(this.contentService);
			this.categorisedScenarios = ScenarioCategoryUtil.categoriseScenarios(this.categorisedScenarioStrings, this.filteredScenarios);
		}
	}

	public deselectScenario(scenario: any): void {
		const scenarioIndex = this.selectedScenarioKeys.indexOf(scenario);
		this.selectedScenarioKeys.splice(scenarioIndex, 1);
	}

	public selectScenario(scenario: string): void {
		this.selectedScenarioKeys.push(scenario);
	}

	public isSelected(id: string): boolean {
		return this.selectedScenarioKeys.includes(id);
	}

	@Memoize()
	public getImagePath(scenarioName: string): SafeUrl {
		return this.scenarioService.getImagePath(scenarioName);
	}

	public saveScenarios(): void {
		this.scenarioService.saveScenarioSelection(this.dialogRef, this.selectedScenarioKeys);
	}

	public closeScenarios(): void {
		this.dialogRef.close();
	}
}
